const routes = [
  {
    index: true,
    label: "JOSHUA CHRISTIAN",
    path: "/",
  },
  {
    label: "About",
    path: "/about",
  },

  {
    label: "Projects",
    path: "/projects",
  },
  {
    label: "Stats",
    path: "/stats",
  },
  {
    label: "Contact",
    path: "/contact",
  },
];

export default routes;
